import * as React from 'react';
import { cn } from '../../lib/utils';

export interface StatTileProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: React.ReactNode;
  detail?: React.ReactNode;
  trend?: 'up' | 'down' | 'flat' | null;
  accent?: 'default' | 'success' | 'warning' | 'error' | 'info';
}

const accentRing: Record<NonNullable<StatTileProps['accent']>, string> = {
  default: '',
  success: 'ring-1 ring-inset ring-[color:var(--color-success)]/20',
  warning: 'ring-1 ring-inset ring-[color:var(--color-warning)]/25',
  error: 'ring-1 ring-inset ring-[color:var(--color-error)]/25',
  info: 'ring-1 ring-inset ring-[color:var(--color-info)]/25',
};

export const StatTile = React.forwardRef<HTMLDivElement, StatTileProps>(
  ({ label, value, detail, accent = 'default', className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col gap-1 rounded-md border border-border bg-bg-card px-4 py-3',
        'transition-colors duration-[150ms] hover:border-border-strong',
        accentRing[accent],
        className
      )}
      {...props}
    >
      <span className="text-[10px] font-semibold uppercase tracking-[0.12em] text-fg-muted">
        {label}
      </span>
      <span className="font-display text-2xl font-semibold leading-tight text-fg">
        {value}
      </span>
      {detail && (
        <span className="text-xs text-fg-secondary">{detail}</span>
      )}
    </div>
  )
);
StatTile.displayName = 'StatTile';
